import { useTranslation } from "react-i18next";
import { bookingAllows } from "../../utils/helpers/standardScope";

/** A visit's focus standards: the stored UUIDs resolved against `rubric` in
 *  rubric order, minus those the lesson `subject` rules out. The server checks
 *  a focus only against the rubric, and a reschedule may change the subject,
 *  so every screen that shows or uses one filters it here, at read time, as
 *  FocusStandardPicker does. */
export const visitFocusStandards = (rubric, uuids, subject) => {
  const picked = new Set(uuids || []);
  return (rubric?.standards || []).filter(
    (std) => picked.has(std.uuid) && bookingAllows(std, subject),
  );
};

// Renders a visit's focus standards, resolved by visitFocusStandards ("S1:
// Introducing Lesson Objectives"), as white pills with an indigo dot. Renders
// nothing for an empty list.
export default function FocusStandardChips({ standards, className = "" }) {
  const { t } = useTranslation();
  if (standards.length === 0) return null;

  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {standards.map((std) => (
        <span
          key={std.uuid}
          className="inline-flex items-center gap-1.5 max-w-full px-2.5 py-1 rounded-full bg-white border border-slate-200 text-[11px] font-bold text-slate-600"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-indigo-500 shrink-0" aria-hidden="true" />
          <span className="truncate">
            {t("upcoming.standardChip", { number: std.number, title: std.title })}
          </span>
        </span>
      ))}
    </div>
  );
}
